import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import {
  geocode as geocodeGoogleMaps,
  reverseGeocode as reverseGeocodeGoogleMaps,
} from './geocoders/googleMapsGeocoder';
import withGoogleMapJS from './withGoogleMapJS';

/* istanbul ignore next */
function geocode({ googleMaps }, address) {
  if (!googleMaps) return noop;
  return geocodeGoogleMaps(googleMaps, address);
}

/* istanbul ignore next */
function reverseGeocode({ googleMaps }, location) {
  if (!googleMaps) return noop;
  return reverseGeocodeGoogleMaps(googleMaps, location);
}

export const withGeocoder = compose(
  withGoogleMapJS,
  withProps(
    /* istanbul ignore next */
    ownerProps => ({
      geocode: address => geocode(ownerProps, address),
      reverseGeocode: location => reverseGeocode(ownerProps, location),
    }),
  ),
);

withGeocoder.propTypes = {
  googleMaps: PropTypes.googleMapsApi,
};

withGeocoder.defaultProps = {
  googleMaps: null,
};

export default withGeocoder;



// WEBPACK FOOTER //
// ./src/features/googleMaps/withGeocoder.js